<template>
    <tbody>
        <tr
            v-for="(item, index) in items"
            :key="index"
            :class="`${isStatusClosed(item) ? 'disabled' : ''}`"
        >
            <!-- === === Index === === -->
            <td class="truncate">{{ item.index }}</td>
            <!-- === === TITLE === === -->
            <td class="truncate">{{ item.title }}</td>
            <!-- === === CONTRACTOR === === -->
            <td class="truncate">
                <DoubleLine
                    :firtstLine="$get(item.contractor, 'name', '')"
                    :secondLine="findRepresentative(item)"
                />
            </td>
            <!-- === === STATUS === === -->
            <td class="truncate">
                <v-chip
                    :color="$get(item, 'status.color.background', '#555555')"
                    :style="`color: ${$get(
                        item,
                        'status.color.font',
                        '#FFFFFF'
                    )}`"
                    dark
                    label
                    small
                    >{{ $get(item, 'status.name', $t('global:empty')) }}</v-chip
                >
            </td>
            <td class="d-flex align-center justify-end">
                <v-icon small v-if="hasFile(item.folders)"
                    >mdi-paperclip</v-icon
                >
                <v-menu bottom v-if="remove()">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-bind="attrs" v-on="on">
                            <v-icon color="iconGray" small
                                >mdi-dots-vertical</v-icon
                            >
                        </v-btn>
                    </template>
                    <v-list dense>
                        <!-- === === REMOVE === === -->
                        <v-list-item @click="openConfirmModal(item._id)">
                            <v-list-item-icon class="mr-0">
                                <v-icon color="red" small>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Usuń</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn small router :to="`/enforcements/${item._id}`" icon>
                    <v-icon color="secondary" small
                        >mdi-arrow-right-thick</v-icon
                    >
                </v-btn>
            </td>
        </tr>
        <ConfirmModal
            :openConfirm="openConfirm"
            @close-confirm="closeConfirmModal"
        >
            <div slot="main"><ConfirmContent /></div>
            <div slot="buttons">
                <div class="d-flex justify-center">
                    <v-btn
                        color="rgb(117, 117, 117)"
                        width="110"
                        height="40"
                        @click="closeConfirmModal()"
                        class="white--text mx-2"
                        >{{ $t('global:cancel') }}</v-btn
                    >
                    <v-btn
                        width="110"
                        height="40"
                        color="#445d75"
                        class="white--text mx-2"
                        @click="deleteItem()"
                        >{{ $t('global:remove') }}</v-btn
                    >
                </div>
            </div>
        </ConfirmModal>
    </tbody>
</template>
<script>
import { mapActions } from 'vuex'
import ConfirmContent from '../ConfirmModal/ConfirmContent.vue'
export default {
    props: ['items'],
    data() {
        return {
            openConfirm: false,
            removeItemID: '',
        }
    },
    components: {
        ConfirmContent,
    },
    methods: {
        ...mapActions(['deleteEnforcements']),
        findRepresentative(item) {
            return `${this.$get(
                item.representative,
                'name',
                'Brak'
            )} ${this.$get(item.representative, 'lastname', '')} ${
                item.representative && item.representative.email ? '•' : ''
            } ${this.$get(item.representative, `email`, '')} ${
                item.representative && item.representative.phoneNumber
                    ? '•'
                    : ''
            } ${this.$get(item.representative, 'phoneNumber', '')}`
        },
        remove() {
            return this.checkPermissions('DELETE')
        },
        openConfirmModal(id) {
            this.removeItemID = id
            this.openConfirm = true
        },
        closeConfirmModal() {
            this.openConfirm = false
        },
        async deleteItem() {
            let result = await this.deleteEnforcements({
                id: this.removeItemID,
            })
            if (result) this.openConfirm = false
        },
    },
}
</script>
